import angular from 'angular';
import uiRouter from 'angular-ui-router';

import { REGULATOR } from 'config/permissions/roles';
import { getQuery, getLimitOptions } from 'utilities/query';
import productsService from './products.service';
import productsComponent from './products.component';
import search from './product-search/product-search.module';
import productLabelPreview from './product-label-preview/product-label-preview.module';
import './products.scss';

export default
  angular.module('components.app.products', [
    uiRouter,
    productLabelPreview,
    search
  ])
    .component('products', productsComponent)
    .service('ProductsService', productsService)
    .config(($stateProvider) => {
      'ngInject';

      $stateProvider
        .state('products', {
          parent: 'app',
          url: '/products',
          component: 'products',
          data: {
            permissions: {
              except: [REGULATOR],
              redirectTo: 'app'
            }
          },
          params: {
            search: {
              value: 'default'
            }
          },
          resolve: {
            flex: () => '100',
            layout: () => 'column',
            user: currentUser => currentUser,
            query: () => getQuery(),
            limitOptions: () => getLimitOptions(),
            alerts: ProductsService =>
              ProductsService.getAlerts().then(r => r.data),
            animalTypes: AnimalTypeService => AnimalTypeService.getAnimalTypes().then(r => r.data),
            products: ($stateParams, query, ProductsService) => {
              ProductsService.setQuery(query);

              if (!$stateParams.search) {
                return ProductsService.getProducts().then(r => r.data);
              }

              if ($stateParams.search === 'missing_sales') {
                return ProductsService.getProductsMissingSalesData().then(r => r.data);
              } else if ($stateParams.search === 'missing_info') {
                return ProductsService.getProductsMissingProductInfo().then(r => r.data);
              }

              return ProductsService.getProducts().then(r => r.data);
            },
            // TODO: Refactor to OData call
            categories: ProductService =>
              ProductService.getCategories().then(r => r.data),
            administrationUnits: ProductService =>
              ProductService.getAdministrationUnits().then(r => r.data),
            searchCriteria: ($stateParams) => {
              let selectedSearchType = 'All Products';
              if ($stateParams.search === 'missing_sales') {
                selectedSearchType = 'Missing - Containers Shipped Data';
              } else if ($stateParams.search === 'missing_info') {
                selectedSearchType = 'Missing - Product Information';
              }

              return {
                selectedSearchType
              };
            },
            searchTypes: ProductsService =>
              ProductsService.getSearchTypes()
          }
        });
    })
    .name;



// WEBPACK FOOTER //
// ./components/app/products/products.module.js